import React from 'react';

import MobileChatIcon from 'components/lib/icons/mobile_chat_icon';

export default function MobileChatMetadataIcon() {
  return (
    <div className="itemMetadata-chatIcon">
      <MobileChatIcon className="mobileChatIconGray" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/chat/mobilechat_metadata_icon.jsx